import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  scenarioContent: {
    minWidth: 150,
    whiteSpace: 'pre',
    marginBottom: 20,
  },
}));
